<template>
  <div class="return-reasons">
    <el-select
        id="return-reason-select-id"
        v-model="selectedAllReason"
        class="return-reason-select"
        popper-class="return-reason-dropdown"
        placeholder="Select return reason">
      <el-option
          v-for="reason in returnReasons"
          :key="reason.id"
          class="return-reason-option"
          :label="reason.text"
          :value="reason.id">
        <span style="float: left">{{ reason.text }}</span>
        <span
            v-if="selectedAllReason === reason.id && showAllCheckMark"
            style="float: right !important;"><img
                style="height: 12.28px; width: 15.78px; padding-top: 5px"
                src="../../../../assets/drop-down-checkmark.svg"></span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "AllReturnReasons",
  props: {
    returnReasons: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedAllReason: null,
      showAllCheckMark: false,
    };
  },
  watch: {
    selectedAllReason: function () {
      this.showAllCheckMark = true;
      this.$emit("selected-all-reason", this.selectedAllReason);
    },
  },
};
</script>

<style>
.return-reasons {
  display: flex;
  align-self: center;
  width: 320px;
  .el-select {
    display: flex;
    align-items: center;
  }
  .el-input__inner {
    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #424242 !important;
  }
  .el-select-dropdown el-popper {
    color: #424242;
  }
  .el-select-dropdown__item {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
}
.return-reason-option {
  height: 40px !important;
  align-items: center !important;
  padding: 8px 16px !important;
  font-family: "Equip" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}
.return-reason-option:hover {
  background-color: #eff8fc !important;
}
.return-reason-select {
  .el-input__inner:focus {
    border: 2px solid #1998d5;
  }
}
.return-reason-dropdown {
  padding: 8px 0 !important;
  border: 1px solid #81919f !important;
  .popper__arrow {
    display: none !important;
  }
  .popper__arrow::after {
    display: none !important;
  }
}
.return-reason-option.selected {
  color: #1476ad !important;
}
</style>
